import rest from "@/rest-client";

/** TKP-89 — modül ayarları. Ürün, istek başlığından (`Product`) okunur; rest-client onu geçerli üründen ekler. */
export const moduleSettings = {
  namespaced: true,
  state: { settings: null, isLoading: false, isUpdating: false },
  getters: {
    settings: (state) => state.settings,
    isLoading: (state) => state.isLoading,
    isUpdating: (state) => state.isUpdating,
  },
  mutations: {
    settings: (state, value) => (state.settings = value),
    isLoading: (state, value) => (state.isLoading = value),
    isUpdating: (state, value) => (state.isUpdating = value),
  },
  actions: {
    async fetch({ commit }) {
      commit("isLoading", true);
      try {
        const response = await rest.get("/module-settings");
        commit("settings", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    async update({ commit }, settings) {
      commit("isUpdating", true);
      try {
        const response = await rest.put("/module-settings", { settings });
        commit("settings", response.data);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
};
